module.exports = __webpack_public_path__ + "Roboto-BoldItalic.65c7b0c96d644be47ca4.woff";


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/src/assets/vendors/base/fonts/googleapi-fonts/Roboto-BoldItalic.woff
// module id = ../../../../../src/assets/vendors/base/fonts/googleapi-fonts/Roboto-BoldItalic.woff
// module chunks = styles